import S_R_E from 'Templates/4tservice/components/service/request.edit/.default/lang/ru.json'
import S_R_N from 'Templates/4tservice/components/service/request.new/.default/lang/ru.json'

const s_r_e = (key) => S_R_E[`s.r.e_${key}`]
const s_r_n = (key) => S_R_N[`s.r.n_${key}`]

export { s_r_e, s_r_n }
